import { render, staticRenderFns } from "./ResidentDetailTab.vue?vue&type=template&id=2ca47e4e&scoped=true&lang=pug"
import script from "./ResidentDetailTab.vue?vue&type=script&lang=ts"
export * from "./ResidentDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./ResidentDetailTab.vue?vue&type=style&index=0&id=2ca47e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca47e4e",
  null
  
)

export default component.exports